export default __webpack_public_path__ + "static/media/RTR1802V_Posterior.db04986e.webp";